module.exports = __webpack_public_path__ + "img/product_4.e7fcc405.png";